import React from 'react';
import {useSurveyContext} from "../../../context/SurveyContext";
import InfoBox from "../InfoBox";

function TextAreaQuestion(props) {
    const {survey: {answers}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id] || "";

    const isShown = props.question.part === props.activePart;

    return (
        <div className={isShown ? "" : "hidden"} onBlur={() => props.validate(props.question, answer)}>
            <label className="text-lg text-grey-darker">
                {props.question.questionText}<br/>
                <textarea
                    className="w-full xl:w-1/2 h-30 border mt-2 text-base"
                    value={answer}
                    onChange={event => setAnswer(props.question.id, event.target.value)} />
            </label>

            {props.question.answerInfo && answer &&
            <InfoBox
                classes="mt-6 md:inline-block"
                infoText={props.question.answerInfo}
            />
            }
        </div>
    )
}

export default TextAreaQuestion;